import * as React from 'react';
import Grid from '@mui/material/Grid';
import { DayItem } from '../../../../interfaces';
import Day from './Day';

type Props = {
  dayItems: DayItem[];
  selectedMonth: Date;
  setSelectedDay: React.Dispatch<React.SetStateAction<Date>>;
  setDayIsSelected: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function DaysRow({
  dayItems,
  selectedMonth,
  setSelectedDay,
  setDayIsSelected,
}: Props) {
  return (
    <div className="calendar-row">
      <Grid container spacing={0} columns={7}>
        {dayItems.map(dayItem => (
          <Day
            day={dayItem}
            selectedMonth={selectedMonth}
            setSelectedDay={setSelectedDay}
            setDayIsSelected={setDayIsSelected}
            key={dayItem.date}
          />
        ))}
      </Grid>
    </div>
  );
}
